import { useEffect, useRef } from 'react'

const DEFAULT_THRESHOLD = 0

type CallbackFunction = (
  entry: IntersectionObserverEntry,
  ref: HTMLDivElement
) => void

export const useIntersectionObserver = (callback: CallbackFunction) => {
  const refParent = useRef<HTMLDivElement>(null)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const observer = new IntersectionObserver(
    entries => {
      // We only need the first entry, since we use a threshold of 0
      const [firstEntry] = entries
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      callback(firstEntry, refParent.current)
    },
    {
      threshold: DEFAULT_THRESHOLD
    }
  )

  useEffect(() => {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    observer.observe(refParent.current)
    return () => {
      observer.disconnect()
    }
  }, [refParent, observer])

  return [refParent]
}
